import { lazy } from "react";

export default lazy(() => import(/* webpackChunkName: "category-icon" */ "./categoty-icon"));
